webpackJsonp([269015366160819],{

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Components = __webpack_require__(112);
	
	var _Components2 = _interopRequireDefault(_Components);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Components2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Introduction'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'While the visual appearance of forms varies significantly from application to application, there are a few components that are generic and purely funtional in nature that you can use to constructor your blueprints if you like the approach that lore-forms follows.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section captures what those components are and how to use them.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-components-index-js-c80c3ffeb7d5647275bd.js